import 'css/RembleTheme.scss'
import 'css/RembleThemeDark.scss'

import { useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Toast, ToastContainer } from 'react-bootstrap'

import { isInApp } from 'components/common/helpers/Mobile'
import { app } from 'config'

import Header from 'components/common/navigation/Header'
import Footer from 'components/common/navigation/Footer'
import Navigation from 'components/common/navigation/Navigation'
import PrivateRoute from 'components/auth/PrivateRoute'
import Logout from 'components/auth/Logout'
import Signup from 'components/auth/Signup'
import Verify from 'components/auth/Verify'
import PaymentComplete from 'components/payments/PaymentComplete'
import Today from 'components/today/Today'
import Subscription from 'components/account/Subscription'
import Profile from 'components/account/Profile'
import CourseDiscovery from 'components/courses/CourseDiscovery'
import CourseDetail from 'components/courses/CourseDetail'
import Lesson from 'components/lessons/Lesson'
import Quiz from 'components/quizzes/Quiz'
import PracticeDiscovery from 'components/practices/PracticeDiscovery'
import JournalFullScreen from 'components/practices/journaling/JournalFullScreen'
import JournalList from 'components/practices/journaling/JournalList'
import Cache from 'components/common/api/Cache'
import BreathingExercise from 'components/practices/breathing/BreathingExercise'
import AffirmationBuilder from 'components/practices/affirmations/AffirmationBuilder'
import AffirmationFullScreen from 'components/practices/affirmations/AffirmationFullScreen'
import AffirmationList from 'components/practices/affirmations/AffirmationList'
import RelationshipConversationsList from 'components/practices/relationship-conversations/RelationshipConversationsList'
import RelationshipConversationsFullScreen from 'components/practices/relationship-conversations/RelationshipConversationsFullScreen'
import BreathingList from 'components/practices/breathing/BreathingList'
import PracticeIntroVideoFullScreen from 'components/practices/PracticeIntroVideoFullScreen'
import PlanSelection from 'components/payments/PlanSelection'
import PaymentForm from 'components/payments/PaymentForm'
import Welcome from 'components/welcome/Welcome'
import SupportRequest from 'components/support/SupportRequest'
import CopingskillsList from 'components/practices/copingskills/CopingskillsList'
import CopingskillsFullScreen from 'components/practices/copingskills/CopingskillsFullScreen'
import DailyJournalFullScreen from 'components/practices/journaling/DailyJournalFullScreen'
import NewJournal from 'components/practices/journaling/NewJournal'
import DailyRemblePlaylist from 'components/daily-remble/DailyRemblePlaylist'
import DailyRemblePlaylistPublic from 'components/daily-remble/DailyRemblePlaylistPublic/DailyRemblePlaylistPublic'

// Routes
import {
  ROUTE_ACTIVITIES_AFFIRMATIONS,
  ROUTE_ACTIVITIES_AFFIRMATIONS_ALL,
  ROUTE_ACTIVITIES_AFFIRMATIONS_BUILDER,
  ROUTE_ACTIVITIES_ALL,
  ROUTE_ACTIVITIES_BREATHING,
  ROUTE_ACTIVITIES_BREATHING_ALL,
  ROUTE_ACTIVITIES_COPINGSKILL,
  ROUTE_ACTIVITIES_COPINGSKILL_INTRO,
  ROUTE_ACTIVITIES_COPINGSKILLS_ALL,
  ROUTE_ACTIVITIES_JOURNALING,
  ROUTE_ACTIVITIES_JOURNALING_ALL,
  ROUTE_ACTIVITIES_JOURNALING_CREATE_JOURNAL,
  ROUTE_ACTIVITIES_JOURNALING_DAILY,
  ROUTE_ACTIVITIES_JOURNALING_EDIT_SAVED_JOURNAL,
  ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL,
  ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL_ALL,
  ROUTE_ACTIVITIES_MEDITATE,
  ROUTE_ACTIVITIES_MEDITATION,
  ROUTE_ACTIVITIES_MEDITATION_ALL,
  ROUTE_ACTIVITIES_RELATIONSHIPQA,
  ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL,
  ROUTE_ARTICLES,
  ROUTE_ARTICLES_ALL,
  ROUTE_COURSES,
  ROUTE_COURSES_ALL,
  ROUTE_DAILY_REMBLE_VIDEO,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_HISTORY,
  ROUTE_LESSONS,
  ROUTE_LOGIN,
  ROUTE_LOGOUT,
  ROUTE_MEMBERSHIP,
  ROUTE_NOTIFICATIONS,
  ROUTE_NOTIFICATIONS_PRACTICES,
  ROUTE_PAYMENTS,
  ROUTE_PAYMENTS_COMPLETE,
  ROUTE_PAYMENTS_DETAILS,
  ROUTE_PRACTICE_INTRO_VIDEO,
  ROUTE_PROFILE,
  ROUTE_QUIZZES,
  ROUTE_SIGNUP,
  ROUTE_SUBSCRIPTION,
  ROUTE_SUBSCRIPTION_CANCEL,
  ROUTE_SUPPORT,
  ROUTE_SUPPORT_RESOURCES,
  ROUTE_TODAY,
  ROUTE_TOPICS,
  ROUTE_VERIFY,
  ROUTE_WELCOME,
  ROUTE_LOGIN_PRIVATE,
  ROUTE_ACTIVITIES_BREATHING_INTRO,
  ROUTE_ACTIVITIES_CUSTOM_MEDITATE,
  ROUTE_LOGIN_OAUTH,
  ROUTE_TOS_ACCEPTANCE,
  ROUTE_ASSESSMENT,
  ROUTE_ASSESSMENT_COMPLETE,
  ROUTE_ACTIVITIES_COMPLIMENTS_ALL,
  ROUTE_ACTIVITIES_COMPLIMENTS,
  ROUTE_ACTIVITIES_DATE_IDEAS,
  ROUTE_ACTIVITIES_DATE_IDEAS_ALL,
  ROUTE_ASSESSMENT_PROGRAM,
  ROUTE_CHAT,
  ROUTE_CHAT_GENERAL,
  ROUTE_CHECK_IN,
  ROUTE_CHECK_IN_SUMMARY,
  ROUTE_LOGIN_OAUTH_OPENID,
  ROUTE_CATEGORY,
  ROUTE_BOOKMARKS,
  ROUTE_LIBRARY
} from 'components/common/helpers/Paths'

import JournalSavedList from './components/practices/journaling/JournalSavedList'
import RembleLogomark from 'assets/images/Remble_Logomark-Green.png'
import ComplimentsList from './components/practices/compliments/ComplimentsList'
import ComplimentFullScreen from './components/practices/compliments/ComplimentFullScreen'
import DateIdeasList from './components/practices/date-ideas/DateIdeasList'
import DateIdeasFullScreen from './components/practices/date-ideas/DateIdeasFullScreen'
import ResourcePage from 'components/support/ResourcePage/ResourcePage'
import ChangeSubscription from 'components/account/ChangeSubscription'
import MeditationList from 'components/practices/meditation/MeditationList'
import MeditationFullscreen from 'components/practices/meditation/MeditationFullscreen'
import Meditations from 'components/practices/meditation/Meditation/Meditation'
import Meditate from './components/practices/custom-meditation/meditate'
import CopingSkillsIntro from 'components/practices/copingskills/CopingSkillsIntro'
import ForgotPassword from 'components/auth/ForgotPassword'
import BreathingIntro from './components/practices/breathing/BreathingIntro'
import ArticlePage from 'components/articles/ArticlePage'
import Notifications from 'components/account/Notifications'
import PracticeNotifications from 'components/account/Notifications/PracticeNotifications'
import MembershipBenefits from 'components/account/MembershipBenefits'
import Bookmarks from './components/today/Bookmarks'
import TimeLine from './components/today/Timeline'
import PrivateLogin from 'components/auth/PrivateLogin'
import OAuthLogin from 'components/auth/OAuthLogin'
import TOSAcceptance from 'components/welcome/TOSAcceptance'
import UserAssessment from 'components/assessment/UserAssessment'
import UserAssessmentComplete from 'components/assessment/UserAssessmentComplete'
import UserProgram from 'components/assessment/UserProgram'
import Chat from 'components/chat/Chat/Chat'
import ChatDashboard from 'components/chat/ChatDashboard'

// Custom contexts
import { CourseProvider } from 'components/common/contexts/CourseContext'
import { SubscriptionProvider } from 'components/common/contexts/SubscriptionContext'
import { UserProgramProvider } from 'components/common/contexts/UserProgramContext'

// Custom hooks
import useInitializeUser from 'components/common/hooks/useInitializeUser'
import Assessment from 'components/my-goals/Assessment'
import { UserCheckinProvider } from 'components/common/contexts/UserCheckinContext'
import Summary from 'components/my-goals/Summary'
import OAuthFlow from 'components/auth/OAuthFlow'
import Library from 'components/today/Library'
import Category from 'components/today/Library/Category'
import ArticlePageList from 'components/articles/ArticleListPage/ArticleListPage'

const cache = new Cache()

// Attempt to load Intercom, but don't worry if it fails
try {
  if (!app.is_local) {
    // See https://www.intercom.com/help/en/articles/170-integrate-intercom-in-a-single-page-app for more info
    window.Intercom('boot', {
      api_base: 'https://api-iam.intercom.io',
      app_id: 'jlicdpt2',
      custom_launcher_selector: '#intercom'
    })

    // Change the Intercom position to be above the tab bar
    window.intercomSettings = {
      horizontal_padding: 20,
      vertical_padding: 100
    }
  }
} catch (e) {
  console.error(e)
}

function App() {
  const {
    courses,
    progress,
    setProgress,
    bookmarks,
    setBookmarks,
    ratings,
    setRatings,
    userSubscription,
    userHasPremiumAccess,
    setUserSubscription,
    isAuthed,
    setIsAuthed,
    userProgram,
    setUserProgram,
    todayUserCheckin,
    setTodayUserCheckin,
    summaryUserCheckin,
    setSummaryUserCheckin
  } = useInitializeUser(cache)

  const [headerTitle, setHeaderTitle] = useState()
  const [returnPath, setReturnPath] = useState()
  const [showToast, setShowToast] = useState(false)

  // TODO: convert to array of messages
  const [toastMessage, setToastMessage] = useState(false)

  return (
    <SubscriptionProvider
      value={{ userSubscription, setUserSubscription, userHasPremiumAccess }}
    >
      <CourseProvider
        value={{
          courses,
          progress,
          setProgress,
          bookmarks,
          setBookmarks,
          ratings,
          setRatings
        }}
      >
        <UserProgramProvider value={{ userProgram, setUserProgram }}>
          <UserCheckinProvider
            value={{
              todayUserCheckin,
              setTodayUserCheckin,
              summaryUserCheckin,
              setSummaryUserCheckin
            }}
          >
            <div className={`App ${isInApp() ? 'native' : ''}`}>
              <Header
                title={headerTitle}
                returnPath={returnPath}
                isAuthenticated={isAuthed}
                setShowToast={setShowToast}
                setToastMessage={setToastMessage}
              />
              <ToastContainer className='p-3'>
                <Toast
                  show={showToast}
                  onClose={_ => setShowToast(false)}
                  position={'top-center'}
                  delay={5000}
                  autohide
                >
                  <Toast.Header>
                    <img
                      className='logomark'
                      src={RembleLogomark}
                      alt='Remble®'
                      width='25'
                      loading='lazy'
                    />
                    <strong className='me-auto' style={{ marginLeft: '10px' }}>
                      Remble®
                    </strong>
                    <small>Just now</small>
                  </Toast.Header>
                  <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>
              </ToastContainer>
              <Switch>
                {/* User Assessment */}
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_ASSESSMENT}
                  component={UserAssessment}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_ASSESSMENT_COMPLETE}
                  component={UserAssessmentComplete}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_ASSESSMENT_PROGRAM}
                  component={UserProgram}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* Chat */}
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_CHAT_GENERAL}
                  component={ChatDashboard}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                <PrivateRoute
                  cache={cache}
                  path={ROUTE_CHAT}
                  component={Chat}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* Compliments */}
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_ACTIVITIES_COMPLIMENTS_ALL}
                  component={ComplimentsList}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_COMPLIMENTS}
                  component={ComplimentFullScreen}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  cache={cache}
                />

                {/* Date ideas */}
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_ACTIVITIES_DATE_IDEAS_ALL}
                  component={DateIdeasList}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_ACTIVITIES_DATE_IDEAS}
                  component={DateIdeasFullScreen}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* Meditation */}
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_ACTIVITIES_MEDITATION_ALL}
                  component={MeditationList}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_ACTIVITIES_CUSTOM_MEDITATE}
                  component={Meditate}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <Route
                  exact
                  path={ROUTE_ACTIVITIES_MEDITATION}
                  render={() => (
                    <MeditationFullscreen
                      setReturnPath={setReturnPath}
                      setHeaderTitle={setHeaderTitle}
                      cache={cache}
                    />
                  )}
                />
                <PrivateRoute
                  exact
                  cache={cache}
                  path={ROUTE_ACTIVITIES_MEDITATE}
                  component={Meditations}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* Journaling */}
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_JOURNALING_ALL}
                  component={JournalList}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_JOURNALING_CREATE_JOURNAL}
                  component={NewJournal}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setShowToast={setShowToast}
                  setToastMessage={setToastMessage}
                />

                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL_ALL}
                  component={JournalSavedList}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setShowToast={setShowToast}
                  setToastMessage={setToastMessage}
                />

                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL}
                  component={JournalSavedList}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setShowToast={setShowToast}
                  setToastMessage={setToastMessage}
                />

                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_JOURNALING}
                  component={JournalFullScreen}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setShowToast={setShowToast}
                  setToastMessage={setToastMessage}
                />

                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_JOURNALING_EDIT_SAVED_JOURNAL}
                  component={DailyJournalFullScreen}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setShowToast={setShowToast}
                  setToastMessage={setToastMessage}
                />

                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_JOURNALING_DAILY}
                  component={DailyJournalFullScreen}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setShowToast={setShowToast}
                  setToastMessage={setToastMessage}
                />

                {/* Coping Skills */}
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_COPINGSKILLS_ALL}
                  component={CopingskillsList}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  cache={cache}
                />
                <Route
                  exact
                  path={ROUTE_ACTIVITIES_COPINGSKILL}
                  render={() => (
                    <CopingskillsFullScreen
                      cache={cache}
                      setReturnPath={setReturnPath}
                      setHeaderTitle={setHeaderTitle}
                    />
                  )}
                />
                <Route
                  exact
                  path={ROUTE_ACTIVITIES_COPINGSKILL_INTRO}
                  render={() => (
                    <CopingSkillsIntro
                      cache={cache}
                      setReturnPath={setReturnPath}
                      setHeaderTitle={setHeaderTitle}
                    />
                  )}
                />

                {/* Relationship Conversations */}
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL}
                  component={RelationshipConversationsList}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  cache={cache}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_RELATIONSHIPQA}
                  component={RelationshipConversationsFullScreen}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  cache={cache}
                />

                {/* Affirmations */}
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_AFFIRMATIONS_ALL}
                  component={AffirmationList}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  cache={cache}
                />
                {/* NOTE: MUST come before the affirmations path, or else it will not take precedence */}
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_AFFIRMATIONS_BUILDER}
                  component={AffirmationBuilder}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_AFFIRMATIONS}
                  component={AffirmationFullScreen}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* Breathwork */}
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_BREATHING_ALL}
                  component={BreathingList}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <Route
                  exact
                  path={ROUTE_ACTIVITIES_BREATHING_INTRO}
                  render={() => (
                    <BreathingIntro
                      setReturnPath={setReturnPath}
                      setHeaderTitle={setHeaderTitle}
                      cache={cache}
                    />
                  )}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_BREATHING}
                  cache={cache}
                  component={BreathingExercise}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                {/* Practices General */}
                <PrivateRoute
                  exact
                  path={ROUTE_PRACTICE_INTRO_VIDEO}
                  component={PracticeIntroVideoFullScreen}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_ACTIVITIES_ALL}
                  component={PracticeDiscovery}
                  setHeaderTitle={setHeaderTitle}
                  setReturnPath={setReturnPath}
                />

                {/* Journeys: Quizes, Topics, Lessons, Courses */}
                <PrivateRoute
                  exact
                  path={ROUTE_QUIZZES}
                  component={Quiz}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setProgress={setProgress}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_TOPICS}
                  component={Lesson}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setProgress={setProgress}
                  setRatings={setRatings}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_LESSONS}
                  component={Lesson}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setProgress={setProgress}
                  setRatings={setRatings}
                />
                <Route
                  exact
                  path={ROUTE_COURSES}
                  render={() => (
                    <CourseDetail
                      cache={cache}
                      setReturnPath={setReturnPath}
                      setHeaderTitle={setHeaderTitle}
                      setProgress={setProgress}
                      setRatings={setRatings}
                    />
                  )}
                />
                <PrivateRoute
                  path={ROUTE_COURSES_ALL}
                  component={CourseDiscovery}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* Email Verification */}
                <Route
                  path={ROUTE_VERIFY}
                  render={props => (
                    <Verify
                      setIsAuthenticated={setIsAuthed}
                      verifiedURL={ROUTE_WELCOME}
                      setReturnPath={setReturnPath}
                      setHeaderTitle={setHeaderTitle}
                      {...props}
                    />
                  )}
                />

                {/* Signup */}
                <Route
                  path={ROUTE_SIGNUP}
                  render={props => (
                    <Signup
                      isAuthenticated={isAuthed}
                      setIsAuthenticated={setIsAuthed}
                      {...props}
                    />
                  )}
                />
              {/* Login */}
              <Route
                path={ROUTE_LOGIN_OAUTH_OPENID}
                exact
                render={props => (
                  <OAuthFlow setIsAuthenticated={setIsAuthed} {...props} />
                )}
              />
              <Route
                path={ROUTE_LOGIN_OAUTH}
                exact
                render={props => (
                  <OAuthLogin setIsAuthenticated={setIsAuthed} {...props} />
                )}
              />

              <Route
                path={ROUTE_LOGIN_PRIVATE}
                component={PrivateLogin}
                setIsAuthenticated={setIsAuthed}
              />
              <Route
                path={ROUTE_LOGIN}
                render={props => (
                  <Signup
                    isAuthenticated={isAuthed}
                    setIsAuthenticated={setIsAuthed}
                    defaultToNewUser={false}
                    {...props}
                  />
                )}
              />

                {/* Forgot Password */}
                <Route
                  path={ROUTE_FORGOT_PASSWORD}
                  render={props => (
                    <ForgotPassword
                      verifiedURL={ROUTE_WELCOME}
                      setReturnPath={setReturnPath}
                      setHeaderTitle={setHeaderTitle}
                      {...props}
                    />
                  )}
                />

                {/* User Account Details */}
                <PrivateRoute
                  exact
                  path={ROUTE_SUBSCRIPTION_CANCEL}
                  component={ChangeSubscription}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setUserSubscription={setUserSubscription}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_SUBSCRIPTION}
                  component={Subscription}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setUserSubscription={setUserSubscription}
                />
                <PrivateRoute
                  path={ROUTE_PROFILE}
                  component={Profile}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setShowToast={setShowToast}
                  setToastMessage={setToastMessage}
                />
                <PrivateRoute
                  path={ROUTE_NOTIFICATIONS_PRACTICES}
                  component={PracticeNotifications}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setShowToast={setShowToast}
                  setToastMessage={setToastMessage}
                />
                <PrivateRoute
                  path={ROUTE_NOTIFICATIONS}
                  component={Notifications}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setShowToast={setShowToast}
                  setToastMessage={setToastMessage}
                />

                {/* Payments */}
                <PrivateRoute
                  exact
                  path={ROUTE_MEMBERSHIP}
                  component={MembershipBenefits}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_PAYMENTS}
                  component={PlanSelection}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_PAYMENTS_COMPLETE}
                  component={PaymentComplete}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setUserSubscription={setUserSubscription}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_PAYMENTS_DETAILS}
                  component={PaymentForm}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* Today */}
                <PrivateRoute
                  exact
                  path={ROUTE_TODAY}
                  component={Today}
                  cache={cache}
                  isAuthenticated={isAuthed}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                  setUserSubscription={setUserSubscription}
                  userSubscription={userSubscription}
                />

                {/* Shared daily remble video path */}
                <Route
                  exact
                  path={ROUTE_DAILY_REMBLE_VIDEO}
                  render={() =>
                    isAuthed ? (
                      <DailyRemblePlaylist
                        cache={cache}
                        isAuthenticated={isAuthed}
                        setReturnPath={setReturnPath}
                        setHeaderTitle={setHeaderTitle}
                      />
                    ) : (
                      <DailyRemblePlaylistPublic />
                    )
                  }
                />

                {/* Bookmarks */}
                <PrivateRoute
                  exact
                  path={ROUTE_BOOKMARKS}
                  component={Bookmarks}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* Library */}
                <PrivateRoute
                  exact
                  path={ROUTE_LIBRARY}
                  component={Library}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                <PrivateRoute
                  exact
                  path={ROUTE_CATEGORY}
                  component={Category}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* History */}
                <PrivateRoute
                  exact
                  path={ROUTE_HISTORY}
                  component={TimeLine}
                  cache={cache}
                  setReturnPath={setReturnPath}
                  setHeaderTitle={setHeaderTitle}
                />

                {/* Welcome and TOS */}
                <PrivateRoute
                  exact
                  path={ROUTE_TOS_ACCEPTANCE}
                  component={TOSAcceptance}
                />
                <PrivateRoute exact path={ROUTE_WELCOME} component={Welcome} />

                {/* Support & Support Resources */}
                <PrivateRoute
                  exact
                  path={ROUTE_SUPPORT}
                  component={SupportRequest}
                  setHeaderTitle={setHeaderTitle}
                  setReturnPath={setReturnPath}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_SUPPORT_RESOURCES}
                  component={ResourcePage}
                  setHeaderTitle={setHeaderTitle}
                  setReturnPath={setReturnPath}
                />

                {/* Remble Articles */}
                <Route
                  exact
                  path={ROUTE_ARTICLES}
                  render={() => (
                    <ArticlePage
                      setHeaderTitle={setHeaderTitle}
                      setReturnPath={setReturnPath}
                    />
                  )}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_ARTICLES_ALL}
                  component={ArticlePageList}
                  setHeaderTitle={setHeaderTitle}
                  setReturnPath={setReturnPath}
                  cache={cache}
                />

                {/* Check-in */}
                <PrivateRoute
                  exact
                  path={ROUTE_CHECK_IN}
                  component={Assessment}
                  setHeaderTitle={setHeaderTitle}
                  setReturnPath={setReturnPath}
                  cache={cache}
                />
                {/* Check-in Summary */}
                <PrivateRoute
                  exact
                  path={ROUTE_CHECK_IN_SUMMARY}
                  component={Summary}
                  setHeaderTitle={setHeaderTitle}
                  setReturnPath={setReturnPath}
                  cache={cache}
                />

                {/* Logout */}
                <Route
                  path={ROUTE_LOGOUT}
                  component={Logout}
                  setIsAuthenticated={setIsAuthed}
                />

                {/* Login */}
                <Route
                  path={ROUTE_LOGIN_OAUTH}
                  render={props => (
                    <OAuthLogin setIsAuthenticated={setIsAuthed} {...props} />
                  )}
                />
                <Route
                  path={ROUTE_LOGIN_PRIVATE}
                  component={PrivateLogin}
                  setIsAuthenticated={setIsAuthed}
                />
                <Route
                  path={ROUTE_LOGIN}
                  render={props => (
                    <Signup
                      isAuthenticated={isAuthed}
                      setIsAuthenticated={setIsAuthed}
                      defaultToNewUser={false}
                      {...props}
                    />
                  )}
                />

                {/* Default path is the unified Signup flow */}
                <Route
                  path=''
                  render={props => (
                    <Signup
                      isAuthenticated={isAuthed}
                      setIsAuthenticated={setIsAuthed}
                      {...props}
                    />
                  )}
                />
              </Switch>
              <Navigation isAuthenticated={isAuthed} />
              <Footer />
            </div>
          </UserCheckinProvider>
        </UserProgramProvider>
      </CourseProvider>
    </SubscriptionProvider>
  )
}

export default App
